import * as THREE from 'three';

import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";


function createTextGeometry(text: string, font: any) {
  const geometry = new TextGeometry(text, {
    font: font,
    size: 1,
    height: 0.5,
    curveSegments: 12,
    bevelEnabled: false
  });
  geometry.center();
  return geometry;
}






const mvElement: HTMLElement = document.getElementById('mvElement') as HTMLElement;
// Wait for the model to finish loading
mvElement.addEventListener('load', () => {
  console.log('Model loaded successfully!');
  let indexSymbol:any = Object.getOwnPropertySymbols(mvElement).find(e => e.description === 'scene');
  if(mvElement != null) { 
    let scene:THREE.Scene = mvElement[indexSymbol as keyof typeof mvElement] as unknown as THREE.Scene;
    console.log(scene);
  

    const loader = new FontLoader();

    loader.load('fonts/helvetiker_regular.typeface.json', function (font) {
      const geometry = createTextGeometry('Hello.   world!', font);
      const material = new THREE.MeshBasicMaterial({ color: 0xffffff });
      const mesh = new THREE.Mesh(geometry, material);
      scene.add(mesh);
    });
  }
});

